export const useStyles = (theme) => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up(960)]: { display: "flex" },
  },
  sectionMobile: {
    display: "none",
    [theme.breakpoints.down(960)]: { display: "flex" },
  },
  root: {
    padding: 20,
    minHeight: "50vh",
  },
  tablerow: {
    "&:hover": {
      cursor: "pointer",
      opacity: 0.3,
    },
  },
});
